var _path, _g, _g2, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgAllPosts = function SvgAllPosts(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    viewBox: "0 0 240 172"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#BBBDBF",
    d: "M119.594 169.601c-45.658 0-82.802-37.144-82.802-82.8C36.792 41.142 73.936 4 119.594 4c45.656 0 82.801 37.142 82.801 82.801 0 45.656-37.145 82.8-82.801 82.8m0-164.704C74.432 4.897 37.69 41.638 37.69 86.8c0 45.161 36.742 81.903 81.904 81.903 45.16 0 81.903-36.742 81.903-81.903S164.754 4.897 119.594 4.897"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#BBBDBF"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M158.943 109.096h47.836v.899h-47.836z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.093 115.762a5.8 5.8 0 0 1-4.137-1.713 5.82 5.82 0 0 1-1.72-4.142c0-1.563.609-3.034 1.718-4.142a5.81 5.81 0 0 1 4.139-1.715c1.566 0 3.038.612 4.146 1.717 1.106 1.105 1.716 2.574 1.716 4.14s-.609 3.032-1.716 4.137a5.83 5.83 0 0 1-4.146 1.718m0-10.813a4.93 4.93 0 0 0-3.506 1.451 4.93 4.93 0 0 0-1.452 3.507c0 1.326.519 2.571 1.457 3.507a4.92 4.92 0 0 0 3.501 1.449 4.93 4.93 0 0 0 3.511-1.454c.936-.933 1.452-2.176 1.452-3.502s-.517-2.569-1.452-3.502a4.93 4.93 0 0 0-3.511-1.456"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    fill: "#BBBDBF"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M27.67 70.264h49.633v.896H27.67z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.358 76.207a5.83 5.83 0 0 1-4.146-1.717 5.8 5.8 0 0 1-1.712-4.138c0-1.568.61-3.035 1.715-4.14a5.83 5.83 0 0 1 4.145-1.717c1.562 0 3.032.607 4.136 1.713a5.863 5.863 0 0 1 0 8.283 5.8 5.8 0 0 1-4.138 1.716m.002-10.812a4.93 4.93 0 0 0-3.509 1.453 4.92 4.92 0 0 0-1.452 3.505 4.9 4.9 0 0 0 1.449 3.502 4.93 4.93 0 0 0 3.51 1.453 4.93 4.93 0 0 0 3.504-1.448 4.97 4.97 0 0 0 0-7.016 4.91 4.91 0 0 0-3.502-1.449"
  }))), /*#__PURE__*/React.createElement("linearGradient", {
    id: "all-posts_svg__a",
    x1: 73.278,
    x2: 176.944,
    y1: 46.977,
    y2: 111.591,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#d91c5c"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#9e1f63"
    }
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#all-posts_svg__a)",
    d: "M149.105 126.824h-16.773c-5.944 0-10.779-4.835-10.779-10.78V61.981c0-5.944 4.835-10.78 10.779-10.78h16.773c5.944 0 10.779 4.836 10.779 10.78v54.063c.001 5.945-4.834 10.78-10.779 10.78m-16.773-72.03c-3.964 0-7.186 3.224-7.186 7.188v54.063c0 3.964 3.222 7.188 7.186 7.188h16.773c3.96 0 7.186-3.224 7.186-7.188V61.981c0-3.966-3.226-7.188-7.186-7.188z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "all-posts_svg__b",
    x1: 69.397,
    x2: 173.071,
    y1: 53.198,
    y2: 117.817,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#faaf40"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.246,
    style: {
      stopColor: "#f79b39"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#f05a28"
    }
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#all-posts_svg__b)",
    d: "M94.04 85.73c-9.468 0-17.169-7.704-17.169-17.172s7.702-17.173 17.169-17.173c9.47 0 17.171 7.706 17.171 17.173 0 9.468-7.701 17.172-17.171 17.172m0-30.751c-7.486 0-13.577 6.091-13.577 13.579 0 7.487 6.091 13.58 13.577 13.58s13.578-6.093 13.578-13.58c0-7.488-6.092-13.579-13.578-13.579"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "all-posts_svg__c",
    x1: 55.919,
    x2: 159.589,
    y1: 74.824,
    y2: 139.44,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#41beb6"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#00a69c"
    }
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#all-posts_svg__c)",
    d: "M107.753 100.176H79.667a1.796 1.796 0 1 1 0-3.593h28.086a1.797 1.797 0 1 1 0 3.593"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "all-posts_svg__d",
    x1: 49.937,
    x2: 153.613,
    y1: 84.418,
    y2: 149.038,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#41beb6"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#00a69c"
    }
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#all-posts_svg__d)",
    d: "M107.753 113.497H79.667a1.795 1.795 0 1 1 0-3.59h28.086a1.796 1.796 0 1 1 0 3.59"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "all-posts_svg__e",
    x1: 43.953,
    x2: 147.629,
    y1: 94.015,
    y2: 158.635,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#41beb6"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#00a69c"
    }
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#all-posts_svg__e)",
    d: "M107.753 126.824H79.667a1.796 1.796 0 1 1 0-3.593h28.086a1.797 1.797 0 1 1 0 3.593"
  })));
};
export default SvgAllPosts;